var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.67 69.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    "data-name": "Layer 47"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.84,
    cy: 34.84,
    r: 33.34,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    strokeMiterlimit: 10,
    d: "M31.81 39v-2.13c0-5.55 7.39-6.22 7.39-10.9 0-2.09-1.63-3.92-4.59-3.92-3.61 0-5.24 2.19-6.26 3.05a.82.82 0 0 1-1.22 0l-1.69-1.63a1 1 0 0 1 0-1.32 12.28 12.28 0 0 1 9.68-4.49c5.3 0 9.38 3.37 9.38 8.21 0 6.41-7.9 7.59-7.9 11.2V39a1 1 0 0 1-1.07 1h-2.75a1 1 0 0 1-.97-1zm2.29 5.92a3.54 3.54 0 1 1-3.51 3.56 3.54 3.54 0 0 1 3.51-3.55z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.65fbdbb9a77ab0371b744dc8d2ab634b.svg";
export { ForwardRef as ReactComponent };